/**
 * RouteFallback — Suspense fallback for lazy-loaded secondary routes.
 *
 * Premium dark skeleton: matches the app shell background (#06111C, same as
 * AppSplash / MIRROR_BG / index.html boot) so a code-split chunk fetch NEVER
 * flashes a white screen between routes. Intentionally minimal — lazy chunks
 * resolve in a few hundred ms on a warm connection, so this is a brief,
 * calm placeholder, not a full skeleton of the destination.
 *
 * Additive + reversible: rendered only while a lazy() route module is in
 * flight; static (critical) routes never trigger it.
 */
export default function RouteFallback() {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ background: "#06111C" }}
      aria-busy="true"
      aria-live="polite"
    >
      <div
        className="w-8 h-8 rounded-full border-2 animate-spin"
        style={{
          borderColor: "hsl(187 72% 50% / 0.18)",
          borderTopColor: "hsl(187 72% 55% / 0.85)",
        }}
      />
    </div>
  );
}
